import React from 'react';
import './WorldDbEmptyStart.css';

const THEMES = ['targets', 'inbox', 'leads'];

const Layer = ({ theme, active }) => (
  <div
    className={`wdEmpty-bgLayer wdEmpty--${theme}${active ? ' is-active' : ''}`}
  >
    <div className="wdEmpty-bg">
      <span className="wdEmpty-glow" />
      <span className="wdEmpty-orb wdEmpty-orb--petrol" />
      <span className="wdEmpty-orb wdEmpty-orb--indigo" />
      <span className="wdEmpty-orb wdEmpty-orb--sky" />
      <span className="wdEmpty-ring" />
    </div>
  </div>
);

const WorldEmptyBackdrop = ({ theme }) => (
  <div
    className={`wdEmpty-backdrop${theme ? ' is-on' : ''}`}
    aria-hidden="true"
  >
    {THEMES.map((name) => (
      <Layer key={name} theme={name} active={theme === name} />
    ))}
  </div>
);

export default WorldEmptyBackdrop;
